import css from "standard/css";

const style = css`
  .delete {
    align-items: center;
    border: var(--border-width-thick) dashed #A5A5A5;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    gap: var(--spacing_inset-md);
    max-width: 768px;
    padding: var(--spacing-xl) var(--spacing_inset-xs);
  }

  .delete__file {
    align-items: center;
    color: var(--color-master-dark);
    display: inline-flex;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    line-height: var(--line-height-lg);
    text-align: inherit;
    text-transform: inherit;
  }

  .delete__img {
    cursor: pointer;
  }
`;

export default style;
